import { getOrderTicketRedemptionCards } from './get-order-ticket-redemption-cards';
export const getOrderTicketRedemptionCardById = (id) => {
    const card = getOrderTicketRedemptionCards().find(c => c.id === id);
    if (!card)
        throw new Error(`Cannot find ticket redemption card with ID: ${id}.`);
    return card;
};
